import { locale } from "localization/en";

export const LitreVolumeState = (validations = [], props) => ({
  value: "",
  name: "literVolume",
  label: locale.actualVolumeDispensed,
  note: locale.pleaseWaitForGasUpToFinish,
  placeholder: "0.000 L",
  validations: [...validations],
  ...props,
});

export const ActualAmountDispenseState = (validations = [], props) => ({
  value: "",
  name: "actualAmountDispense",
  label: locale.actualAmountDispensed,
  note: locale.pleaseWaitForGasUpToFinish,
  placeholder: "0.00",
  validations: [...validations],
  ...props,
});

export const DiscountPerLiterState = (validations = [], props) => ({
  value: "",
  name: "discountPerLiter",
  placeholder: "0.00 / L",
  validations: [...validations],
  maxLength: 13,
  ...props,
});

export const pumpPriceState = (validations = [], props) => ({
  value: "",
  name: "pumpPrice",
  label: locale.pumpPrice,
  placeholder: "0.00 / L",
  validations: [...validations],
  maxLength: 13,
  ...props,
});
